import ImageLightbox from './components/ImageLightbox'

export default ImageLightbox
